/* ==========================================
   MUSIC LIBRARY
========================================== */

function initMusicLibrary() {

  const grid =
    document.querySelector(
      "[data-music-grid]"
    );


  if (!grid) {
    return;
  }


  if (
    grid.dataset.musicLibraryInitialized ===
    "true"
  ) {
    return;
  }


  grid.dataset.musicLibraryInitialized =
    "true";


  let cards =
    Array.from(
      grid.querySelectorAll(
        ".music-card"
      )
    );


  let selectedCard =
    null;


  /* ========================================
     DATE SORTING
  ======================================== */

  function getDateValue(
    value
  ) {

    if (!value) {
      return 0;
    }


    const timestamp =
      Date.parse(
        value
      );


    return Number.isNaN(
      timestamp
    )
      ? 0
      : timestamp;

  }


  function sortCards() {

    cards.sort(
      (a, b) => {

        return (
          getDateValue(
            b.dataset.releaseDate
          ) -
          getDateValue(
            a.dataset.releaseDate
          )
        );

      }
    );


    cards.forEach(
      (card) => {

        grid.appendChild(
          card
        );

      }
    );

  }


  sortCards();


  /*
    Refresh after DOM reorder.
  */

  cards =
    Array.from(
      grid.querySelectorAll(
        ".music-card"
      )
    );


  /* ========================================
     TRANSITION HELPERS
  ======================================== */

  function isSingleCard(
    card
  ) {

    return (
      card?.dataset.musicType ===
      "single"
    );

  }


  function clearTransitionNames() {

    cards.forEach(
      (card) => {

        const cover =
          card.querySelector(
            ".music-card-cover img"
          );


        const info =
          card.querySelector(
            ".music-card-info"
          );


        if (cover) {

          cover.style.removeProperty(
            "view-transition-name"
          );

        }


        if (info) {

          info.style.removeProperty(
            "view-transition-name"
          );

        }

      }
    );

  }


  function prepareTransition(
    card
  ) {

    clearTransitionNames();


    /*
      Singles intentionally use normal
      navigation.

      The dynamic ?single= page was
      intermittently unstable with the
      shared cross-document transition.
    */

    if (
      isSingleCard(
        card
      )
    ) {
      return;
    }


    const cover =
      card.querySelector(
        ".music-card-cover img"
      );


    const info =
      card.querySelector(
        ".music-card-info"
      );


    if (cover) {

      cover.style.viewTransitionName =
        "featured-release-cover";

    }


    if (info) {

      info.style.viewTransitionName =
        "featured-release-info";

    }

  }


  /* ========================================
     CARD CLICKS
  ======================================== */

  cards.forEach(
    (card) => {

      card.addEventListener(
        "click",
        (event) => {

          /*
            Don't prepare transitions for
            alternate-tab/window clicks.
          */

          if (
            event.ctrlKey ||
            event.metaKey ||
            event.shiftKey ||
            event.altKey
          ) {
            return;
          }


          selectedCard =
            card;

        }
      );

    }
  );


  /* ========================================
     PAGE SWAP
  ======================================== */

  if (
    !window.__musicLibraryPageswapBound
  ) {

    window.__musicLibraryPageswapBound =
      true;


    window.addEventListener(
      "pageswap",
      (event) => {

        if (
          !event.viewTransition ||
          !selectedCard
        ) {
          return;
        }


        /*
          Singles don't receive shared
          transition names.
        */

        if (
          isSingleCard(
            selectedCard
          )
        ) {

          selectedCard =
            null;

          return;

        }


        prepareTransition(
          selectedCard
        );


        event.viewTransition.finished
          .finally(
            () => {

              clearTransitionNames();


              selectedCard =
                null;

            }
          );

      }
    );

  }


  /* ========================================
     BACK BUTTON CLEANUP
  ======================================== */

  window.addEventListener(
    "pageshow",
    () => {

      clearTransitionNames();


      selectedCard =
        null;

    }
  );

}


/* ==========================================
   LOAD
========================================== */

document.addEventListener(
  "DOMContentLoaded",
  initMusicLibrary
);


document.addEventListener(
  "shopify:section:load",
  initMusicLibrary
);


initMusicLibrary();